const topics = [
  { tag: '悬疑烧脑', heat: '98.6万', desc: '高能反转神剧合集', icon: 'ri-ghost-line', color: 'bg-accent-100 text-accent-700' },
  { tag: '古装大剧', heat: '87.3万', desc: '经典与新风尚', icon: 'ri-vip-crown-line', color: 'bg-primary-100 text-primary-700' },
  { tag: '甜宠爱情', heat: '76.8万', desc: '高糖CP一次嗑够', icon: 'ri-heart-line', color: 'bg-accent-100 text-accent-700' },
  { tag: '硬核科幻', heat: '65.2万', desc: '想象力颠覆认知', icon: 'ri-rocket-line', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '热血动作', heat: '82.1万', desc: '肾上腺素飙升', icon: 'ri-flashlight-line', color: 'bg-primary-100 text-primary-700' },
  { tag: '搞笑喜剧', heat: '71.5万', desc: '笑到停不下来', icon: 'ri-emotion-laugh-line', color: 'bg-accent-100 text-accent-700' },
  { tag: '真实纪录', heat: '53.9万', desc: '看见更大的世界', icon: 'ri-earth-line', color: 'bg-secondary-100 text-secondary-700' },
  { tag: '热门综艺', heat: '90.4万', desc: '话题不断爆款频出', icon: 'ri-tv-line', color: 'bg-primary-100 text-primary-700' },
  { tag: '动画动漫', heat: '68.7万', desc: '国漫崛起力作云集', icon: 'ri-emotion-line', color: 'bg-accent-100 text-accent-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-10 md:py-14 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-8 gap-3">
          <div>
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-1">
              热门话题
            </h2>
            <p className="text-sm text-foreground-500">大家都在追的类型，看看哪个是你的菜</p>
          </div>
          <span className="text-xs text-foreground-400 flex items-center gap-1 whitespace-nowrap">
            <i className="ri-time-line"></i>
            实时热度更新
          </span>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {topics.map((topic) => (
            <a
              key={topic.tag}
              href="#ranking"
              onClick={(e) => {
                e.preventDefault();
                const el = document.querySelector('#ranking');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group flex items-start gap-3 p-4 rounded-xl bg-background-100 hover:bg-background-200/70 border border-background-200/60 transition-all cursor-pointer"
            >
              <span className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg ${topic.color}`}>
                <i className={`${topic.icon} text-base`}></i>
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap">{topic.tag}</h3>
                  <span className="text-xs text-accent-600 font-medium whitespace-nowrap">{topic.heat}</span>
                </div>
                <p className="text-xs text-foreground-500 mt-1">{topic.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}